// markdown-to-jsx labels a fenced block `language-<lang> lang-<lang>`.
export const getCodeLanguage = (
  className: string | undefined
): string | undefined =>
  className
    ?.split(' ')
    .find((token) => token.startsWith('language-'))
    ?.slice('language-'.length);
